(() => {
  if (window.yeswoodProductEditorialInitialized) return;
  window.yeswoodProductEditorialInitialized = true;
  const strings = window.yeswoodProductStrings || {};

  let lastDialogTrigger;

  const syncVariantView = (root) => {
    if (!root?.classList.contains('yeswood-product--editorial')) return;
    const view = root.dataset.yeswoodVariantView === 'grid' ? 'grid' : 'list';
    root.dataset.yeswoodVariantView = view;
    root.querySelectorAll('[data-yeswood-variant-view-toggle]').forEach((button) => {
      const isGrid = view === 'grid';
      const label = isGrid ? strings.viewList || 'Switch to list view' : strings.viewGrid || 'Switch to image grid';
      button.setAttribute('aria-pressed', String(isGrid));
      button.setAttribute('aria-label', label);
      const labelNode = button.querySelector('[data-yeswood-variant-view-label]');
      if (labelNode) labelNode.textContent = label;
    });
    root.querySelectorAll('.yeswood-editorial-variant-card__media img').forEach((image) => {
      const width = view === 'grid' ? Math.ceil(image.getBoundingClientRect().width) || 52 : 52;
      image.sizes = `${width}px`;
    });
  };

  const syncVariantViews = () => {
    document.querySelectorAll('product-info.yeswood-product--editorial').forEach(syncVariantView);
  };

  const ensureDialog = () => {
    let dialog = document.querySelector('#YeswoodVariantMediaDialog');
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.id = 'YeswoodVariantMediaDialog';
    dialog.className = 'yeswood-editorial-variant-dialog';
    dialog.innerHTML = [
      '<div class="yeswood-editorial-variant-dialog__header">',
      '<h2 class="yeswood-editorial-variant-dialog__title"></h2>',
      '<button class="yeswood-editorial-variant-dialog__close" type="button">×</button>',
      '</div>',
      '<img class="yeswood-editorial-variant-dialog__image" alt="">',
      '<p class="yeswood-editorial-variant-dialog__error" role="status" hidden></p>',
    ].join('');
    document.body.append(dialog);

    const image = dialog.querySelector('.yeswood-editorial-variant-dialog__image');
    const error = dialog.querySelector('.yeswood-editorial-variant-dialog__error');
    error.textContent = strings.imageError || 'Image failed to load. Close and try again.';
    dialog.querySelector('.yeswood-editorial-variant-dialog__close').autofocus = true;
    dialog.querySelector('.yeswood-editorial-variant-dialog__close').setAttribute('aria-label', strings.closeVariant || 'Close variant image');
    image.addEventListener('load', () => {
      image.hidden = false;
      error.hidden = true;
    });
    image.addEventListener('error', () => {
      image.hidden = true;
      error.hidden = false;
    });
    dialog.querySelector('.yeswood-editorial-variant-dialog__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (lastDialogTrigger?.isConnected !== false) lastDialogTrigger?.focus({ preventScroll: true });
      lastDialogTrigger = undefined;
    });

    return dialog;
  };

  document.addEventListener('click', (event) => {
    const viewToggle = event.target.closest('[data-yeswood-variant-view-toggle]');
    if (viewToggle) {
      const root = viewToggle.closest('product-info.yeswood-product--editorial');
      if (!root) return;
      root.dataset.yeswoodVariantView = root.dataset.yeswoodVariantView === 'grid' ? 'list' : 'grid';
      syncVariantView(root);
      return;
    }

    const trigger = event.target.closest('[data-yeswood-variant-media-open]');
    if (!trigger) return;

    lastDialogTrigger = trigger;
    const dialog = ensureDialog();
    const image = dialog.querySelector('.yeswood-editorial-variant-dialog__image');
    const error = dialog.querySelector('.yeswood-editorial-variant-dialog__error');
    const title = trigger.dataset.yeswoodVariantMediaTitle || trigger.dataset.yeswoodVariantMediaAlt || 'Product image';
    dialog.querySelector('.yeswood-editorial-variant-dialog__title').textContent = title;
    dialog.ariaLabel = title;
    error.hidden = true;
    image.hidden = false;
    image.alt = (trigger.dataset.yeswoodVariantMediaAlt || '').replace(/\s*\[local:[^\]]*\]/g, '').trim();
    image.src = trigger.dataset.yeswoodVariantMediaSrc;
    dialog.showModal();
  });

  document.addEventListener('click', (event) => {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    const thumbnail = event.target.closest('.yeswood-product--editorial .thumbnail');
    const targetId = thumbnail?.closest('[data-target]')?.dataset.target;
    const mediaGallery = thumbnail?.closest('media-gallery');
    if (!thumbnail || !targetId || typeof mediaGallery?.setActiveMedia !== 'function') return;

    event.preventDefault();
    event.stopPropagation();
    thumbnail.setAttribute('data-yeswood-editorial-thumbnail-target', targetId);
    mediaGallery.setActiveMedia(targetId, false);
  }, true);

  document.addEventListener('shopify:section:load', syncVariantViews);
  window.addEventListener('resize', syncVariantViews);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => window.requestAnimationFrame(syncVariantViews));
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncVariantViews, { once: true });
  } else {
    syncVariantViews();
  }
})();
